const module = { name: 'layouts/mobile.app', exports: {} }; const exports = module.exports;



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { fd_location as fd_location_locationFormCreation } from 'require-global';

const { locationFormCreation } = fd_location_locationFormCreation;


import { fd_url_manager as links } from 'require-core';



import { Fandango_debugLog as debugLog } from 'require-core';



import { default as localeDetector } from 'swug-fdRequire-call:fd-location/localeDetector';



import { default as modal } from 'swug-fdRequire-call:Fandango/modal';



import { default as regionSelector } from 'swug-fdRequire-call:fd-location/regionSelector';



import { Fandango_overlay as overlay } from 'base-libraries';



import { Fandango_xhr as xhr } from 'require-core';



import { default as offerBanner } from 'swug-fdRequire-call:shared/global/offerBanner';



import { default as sidebar } from 'swug-fdRequire-call:mobile/sidebar';



import { default as overlayAuto } from 'swug-fdRequire-call:shared/misc/overlayAuto';



import { global_tracking_passiveEvents as passiveEvents } from 'require-global';



import { default as searchAutocompleteFormCreation } from 'swug-fdRequire-call:mobile/searchAutocomplete/form/creation';



import { default as swInstall } from 'swug-fdRequire-call:mobile/global/sw-install';



import { default as header } from 'swug-fdRequire-call:mobile/global/header';



const Classes = {
    OFFER_MODAL_CTA: '.js-offer-modal-cta',
}


const Selectors = {
    OFFER_MODAL_CTA_BANNER: `${Classes.OFFER_MODAL_CTA}:not([data-overlay-id])`,
    OFFER_MODAL_CTA_GLOBAL: `${Classes.OFFER_MODAL_CTA}[data-overlay-id]`,
    OFFER_MODAL_PREFIX: '#movie-offer-modal-',
}
function onOfferClick() {
    const { offerId } = this.dataset;
    if (!offerId) {
        return debugLog.warn(module.name, 'offer opener missing id');
    }
    overlay.open(document.querySelector(Selectors.OFFER_MODAL_PREFIX + offerId), {
        removeOnClose: false
    });
}
function initOffersModal() {
    modal.offers(Selectors.OFFER_MODAL_CTA_BANNER);
    document.querySelectorAll(Selectors.OFFER_MODAL_CTA_GLOBAL).forEach((offer) => {
        offer.addEventListener('click', onOfferClick);
    });
}
function run() {
    checkDependencies(module.name, debugLog);
    initOffersModal();
    xhr.init({
        tokenURI: links.napiAccountThemePreferences(),
        isMobile: false,
        timeout: 20000,
    });
    searchAutocompleteFormCreation.init();
    locationFormCreation.init();
    passiveEvents.attach();
    overlayAuto.init();
    swInstall.init();
    offerBanner.init();
    header.init();
    sidebar.init();
    regionSelector.init();
    localeDetector.init();
}
run();
export default module.exports;